import React from 'react'
import PropTypes from 'prop-types'
import { map, get } from 'lodash-es'

import {
  PollItemWrapperComponent,
  PollCreateEditFormComponent,
  PollAnsweredComponent,
} from '..'
import { intToBool } from '../../../../utils'

import './PollsListComponent.scss'

const getStyleForTrailColor = (trailColor) =>
  `.polls-list-component .ant-progress-inner { background-color: ${trailColor} }`

const PollsListComponent = (props) => {
  const {
    polls,
    renderPollUnitWrapper,
    deletePoll,
    styles,
    toggleEditPoll,
    editPollsIds,
    accentColor,
    iconColor,
    onCreateEditSubmit,
    activePoll,
    activatePoll,
    canChangePoll,
    isVotingAllowed,
    answerPoll,
    answeredPollIds,
    togglePollOverlay,
    disableOverlayTrigger,
  } = props

  // antd Progress doesn't pick trailColor so we set it up here once
  const trailColor = get(styles, 'progressBarStyles.trailColor')

  if (polls.length === 0) return null

  return (
    <div className="polls-list-component">
      {trailColor && (
        <style
          // TODO: fix linting
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: getStyleForTrailColor(trailColor),
          }}
        />
      )}
      {map(polls, (poll) => {
        const pollId = poll.poll_id
        const isEditing = editPollsIds.has(pollId)
        const handleEditPoll = () => toggleEditPoll(pollId)
        const commonProps = { key: pollId, poll, styles, renderPollUnitWrapper }
        const isPollAnswered =
          answeredPollIds.has(pollId) && intToBool(poll.open_p)

        if (isPollAnswered) {
          return (
            <PollAnsweredComponent
              {...commonProps}
              closeIconColor={iconColor}
              iconColor={get(styles, 'radioButtonStyles.activeColor')}
            />
          )
        }

        if (isEditing) {
          return (
            <PollCreateEditFormComponent
              {...commonProps}
              form={`poll-edit-${pollId}-form`}
              accentColor={accentColor}
              iconColor={iconColor}
              onCancelPollChanges={handleEditPoll}
              onSubmit={onCreateEditSubmit}
            />
          )
        }

        return (
          <PollItemWrapperComponent
            {...commonProps}
            editPoll={handleEditPoll}
            deletePoll={() => deletePoll(pollId)}
            activePoll={activePoll}
            activatePoll={() => activatePoll(poll)}
            canChangePoll={canChangePoll}
            isVotingAllowed={isVotingAllowed}
            answerPoll={answerPoll}
            answeredPollIds={answeredPollIds}
            togglePollOverlay={togglePollOverlay}
            disableOverlayTrigger={disableOverlayTrigger}
          />
        )
      })}
    </div>
  )
}

PollsListComponent.propTypes = {
  polls: PropTypes.arrayOf(PropTypes.object),
  renderPollUnitWrapper: PropTypes.func,
  deletePoll: PropTypes.func,
  toggleEditPoll: PropTypes.func,
  onCreateEditSubmit: PropTypes.func,
  editPollsIds: PropTypes.object, // Set()
  styles: PropTypes.shape({
    inputStyle: PropTypes.object,
    secondaryButtonStyle: PropTypes.object,
    buttonStyle: PropTypes.object,
    progressBarStyles: PropTypes.object,
    radioButtonStyles: PropTypes.object,
  }),
  togglePollOverlay: PropTypes.func,
  accentColor: PropTypes.string,
  iconColor: PropTypes.string,
  activePoll: PropTypes.object,
  activatePoll: PropTypes.func,
  answerPoll: PropTypes.func,
  canChangePoll: PropTypes.bool,
  isVotingAllowed: PropTypes.bool,
  answeredPollIds: PropTypes.object, // Set()
  disableOverlayTrigger: PropTypes.bool,
}

export default PollsListComponent
